import { deleteTimeAssignment } from "@/api/timeAssignments/deleteTimeAssignment";
import { useMutation } from "@tanstack/react-query";

export const useDeleteTimeAssignment = () => {
  return useMutation({
    mutationKey: ["deleteTimeAssignment"],
    mutationFn: deleteTimeAssignment,
  });
};